<template functional>
  <div
    id="freewheel"
    class="c-freewheel c-freewheel--embedded"
    @mousemove="parent.handleMouseMove"
  >
    <div
      v-show="parent.isAdvertPlayerActive"
      class="c-freewheel__player"
      @click="parent.onClick"
    >
      <!-- Android Webview requires poster image, otherwise throws error destroying player -->
      <video
        class="js-freewheel-video"
        poster="/static/images/fake-android-webview-poster.gif"
        playsinline
      ></video>
      <div
        class="c-freewheel__controls c-freewheel__controls--embedded"
        :class="{ 'is-active': parent.isVisible }"
        @click="parent.stopPropagation"
      >
        <div
          v-if="parent.duration"
          class="u-flex c-player__btn--fill"
        >
          <div class="c-progress-bar__wrapper">
            <ui-track-bar
              v-if="parent.duration"
              class="c-track-bar--no-pointer"
              :value="parent.progress"
              :focusable="false"
              no-thumb
            ></ui-track-bar>
          </div>
        </div>
        <div class="c-player__control-buttons c-player__control-buttons--embedded">
          <div class="u-flex u-flex-row u-flex-align-center">
            <div class="c-player__btn">
              <ui-player-toggle-play></ui-player-toggle-play>
            </div>
            <div class="c-progress-bar__time">
              {{ parent.currentTime | timeFormatExclusive }}
            </div>
            <span> / </span>
            <div class="c-progress-bar__time">
              {{ parent.duration | timeFormatExclusive }}
            </div>
          </div>
          <div class="u-flex u-flex-row u-flex-align-center">
            <div class="c-player__btn">
              <ui-player-volume></ui-player-volume>
            </div>
            <div
              v-if="!parent.$window.isIOSDevice"
              class="c-player__btn"
            >
              <ui-player-fullscreen-btn></ui-player-fullscreen-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="c-freewheel__info-container">
        <ui-upsell-button
          v-if="parent.product"
          :product="parent.product"
          is-embedded
        ></ui-upsell-button>
        <span
          v-if="parent.showCounter"
          class="c-freewheel__counter-container"
        >
          {{ parent.$t('player.adverts.counter', { adIndex: parent.adIndex, adCount: parent.adCount }) }}
          <span class="c-freewheel__counter-connector"> | </span>
          {{ parent.$t('player.adverts.totalTimeLeft', { totalTimeLeft: parent.totalTimeLeft }) }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  import { timeFormatExclusive } from '@/index/shared/filters';

  export default {
    filters: {
      timeFormatExclusive,
    },
  };
</script>
